import React from 'react';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import { toJS } from 'mobx';
import { Button, Modal, Tabs } from 'antd';
import Search from './Search';
import Table from './Table';
import AddTag from './AddTag';
import NewTag from './NewTag';
import Detail from './Detail';
import DetailConfig from './DetailConfig';
import MainTainerConfig from './MainTainerConfig';
import ReleaseNamesConfig from './releaseNamesConfig';

const { confirm } = Modal;
const { TabPane } = Tabs;

@inject('ecodeDemoStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    formPrefixCls: 'sys-basic',
		prefixCls: 'sys-user',
  }
  componentDidMount() {
    const { ecodeDemoStore: { mainSwitch, getSearchTags, getKbList } } = this.props;
    let { ecodeDemoStore: { activitykey, initDatas } } = this.props;
    const hash = window.location.hash;
    let pathname = ''
    if (hash.lastIndexOf('/') >=0) {
      pathname = hash.slice(hash.lastIndexOf('/') + 1);
      if (hash.indexOf('?') >= 0) {
        pathname = hash.slice(0, hash.indexOf('?') + 1);
      }
    }
    if (pathname && pathname !== activitykey) {
      activitykey = pathname;
    }
    initDatas(activitykey);
    mainSwitch();
    getSearchTags();
    getKbList();
  }
  componentWillReceiveProps(props) {
    const { ecodeDemoStore: { activitykey, setMobxState } } = this.props;
    activitykey !== 'all' && setMobxState({tabsActiveKey: 'all'});
  }
  onChangeSearchValue = (values) => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ searchFormValue: values });
  }
  getParams = (params = {}) => {
    const param = {};
    Object.keys(params).forEach(v => {
      if (params[v]) param[v] = params[v];
    });
    if (params.subDate && params.subDate.length > 0) {
      param.startDate = param.subDate[0];
      param.endDate = param.subDate[1];
    }
    delete param.subDate;
    // if (param.loginType === 'all') delete param.loginType;
    return param;
  }
  showNewTag = () => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ visibleOfNewTag: true });
  }
  onChange = activeKey => {
    const { ecodeDemoStore: { setMobxState, getLogList, init } } = this.props;
    setMobxState({tabsActiveKey: activeKey});
    init();
    getLogList();
  }
  renderTabs = () => {
    const { prefixCls, ecodeDemoStore: { tabsActiveKey, setMobxState } } = this.props;
    const tabList = [{
      key: 'all',
      lable: '全部',
    },{
      key: 'app',
      lable: '应用',
    },{
      key: 'mine',
      lable: '我的',
    },{
      key: 'commitLog',
      lable: '提交日志',
    },]
    return (
      <Tabs activeKey={tabsActiveKey} onChange={activeKey => this.onChange(activeKey)} className={`${prefixCls}`}>
        {
          tabList.map(tab => 
            <TabPane tab={tab.lable} key={tab.key}></TabPane>
          )
        }
      </Tabs>
    );
  }
  render() {
    const { prefixCls, formPrefixCls, ecodeDemoStore: { activitykey, tagSelectedRowKeys, deleteTag, recoverDemo, demoSelectedRowKeys } } = this.props;
    const wrapCls = classNames({
      [`${prefixCls}`]: true,
      [`${formPrefixCls}`]: true,
      'sys-ecode': true,
    });
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    return (
      <div className={wrapCls}>
        {
          activitykey === 'tagmanage' && (
            <div className={`${prefixCls}-row-btn`}>
              <Button
                key="delEcodeDemo"
                disabled={toJS(tagSelectedRowKeys).length === 0}
                onClick={() => {
                  confirm({
                    title: `确认删除选中标签吗?`,
                    onOk: () => {
                      deleteTag();
                    },
                  });
                }}>批量删除</Button>
              <Button key="addEcodeDemo" onClick={(e) => {
                this.showNewTag();
              }}>添加</Button>
            </div>
          )
        }
        {
          activitykey === 'demorenew' && (
            <div className={`${prefixCls}-row-btn`}>
              <Button key="restoreEcodeDemo"
                disabled={toJS(demoSelectedRowKeys).length === 0}
                onClick={(e) => {
                confirm({
                  title: `确认恢复选中案例吗?`,
                  onOk: () => {
                    recoverDemo();
                  },
                });
              }}>批量恢复</Button>
            </div>
          )
        }
        {
          activitykey === 'all' && (
            <div className={`${prefixCls}-row-tabs`}>
              {this.renderTabs()}
            </div>
          )
        }
        <Search {...this.props}onChange={this.onChangeSearchValue} getParams={this.getParams} />
        <Table {...this.props} key={activitykey} getParams={this.getParams} />
        <AddTag {...this.props} formItemLayout={formItemLayout} getParams={this.getParams} />
        <NewTag {...this.props} formItemLayout={formItemLayout} />
        <Detail {...this.props} formItemLayout={formItemLayout} />
        <DetailConfig {...this.props} />
        <MainTainerConfig {...this.props} />
        <ReleaseNamesConfig {...this.props} />
      </div>
    )
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/index.js